import useGetProductRentDates from './useGetProductRentDates'
export default useGetProductRentDates
